import React from "react";

const ButtonContainer = ({
    activeType = "",
    onSelect,
    canManage,
    emailVerified,
}) => {
    const managementItems = [
        { text: "Обзор", typeM: "" },
        ...(canManage ? [
            { text: "Редактор профиля", typeM: "editProfile" },
            {
                text: "Email и безопасность",
                typeM: "security",
                badge: emailVerified ? "" : "!",
            },
            { text: "Роль и доступ", typeM: "editRoleUser" },
        ] : []),
    ];

    const dataItems = [
        { text: "Подписки", typeM: "subscribers" },
        { text: "Баланс и подписка", typeM: "billing" },
        { text: "Корзина", typeM: "cart" },
        { text: "Понравившиеся", typeM: "desires" },
        { text: "История товаров", typeM: "productHistory" },
    ];

    const renderGroup = (title, items) => (
        <div className="userManagementNav__group">
            <span className="userManagementNav__groupTitle">{title}</span>
            <div className="userManagementNav__items">
                {items.map((item) => {
                    const active = String(activeType || "") === String(item.typeM || "");

                    return (
                        <button
                            type="button"
                            key={item.typeM || "overview"}
                            className={active ? "is-active" : ""}
                            onClick={() => onSelect?.(item.typeM)}
                        >
                            <span>{item.text}</span>
                            {item.badge ? <b className="is-warning">{item.badge}</b> : null}
                        </button>
                    );
                })}
            </div>
        </div>
    );

    return (
        <nav className="userManagementNav" aria-label="Управление пользователем">
            {renderGroup("Пользователь", managementItems)}
            {renderGroup("Данные", dataItems)}
        </nav>
    );
};

export default ButtonContainer;
